<template>
  <article id="article-model">
    <section id="port-detail">
      <div class="header">
        <img :src="`${publicPath}/fund/amc/KSAM.png`" />
        <div class="header-detail">
          <h1>KFSMART</h1>
          <p>กรุงศรีสมาร์ทตราสารหนี้</p>
        </div>
      </div>

      <!-- <h2>ทำไมถึงเลือกลงทุนกองนี้?</h2>
      <p>
        FINNOMENA Investment Team แนะนำกองทุน TMBTM
        เพราะ TMBTM มีการเลือกลงทุนในตราสารหนี้ระยะสั้น ตั๋วเงินคลัง และเงินฝากที่มั่นคง มีสภาพคล่องสูง และให้อัตราผลตอบแทนที่ดี
        ส่งผลให้เป็นกองทุนที่ตอบโจทย์ 3 ข้อของนักลงทุนที่ต้องการพักเงินระยะสั้นคือ อัตราผลตอบแทนที่โดดเด่นเมื่อเทียบกับกองทุนในหมวดเดียวกัน ขณะที่ความผันผวนอยู่ในระดับที่ต่ำกว่าค่าเฉลี่ยอย่างสม่ำเสมอ พร้อมกับสภาพคล่องที่สูง (T+1)
      </p> -->

      <h2>ผลตอบแทนย้อนหลัง</h2>
      <table>
        <tr>
          <th>1M</th>
          <th>3M</th>
          <th>6M</th>
          <th>1Y</th>
        </tr>
        <tr>
          <td>
            <div>{{ fundData.total_return_1m | percent }}</div>
          </td>
          <td>
            <div>{{ fundData.total_return_3m | percent }}</div>
          </td>
          <td>
            <div>{{ fundData.total_return_6m | percent }}</div>
          </td>
          <td>
            <div>{{ fundData.total_return_1y | percent }}</div>
          </td>
        </tr>
      </table>
    </section>

    <section id="disclaimer">
      <p>
        *ผลการดำเนินงานในอดีต/ผลการเปรียบเทียบ ผลการดำเนินงานที่
        เกี่ยวข้องกับผลิตภัณฑ์ในตลาดทุน มิได้เป็นสิ่งยืนยันถึงผลการดำเนิน
        งานในอนาคต
      </p>
      <p>
        *ทำความเข้าใจลักษณะสินค้า เงื่อนไขผลตอบแทน และความเสี่ยงก่อน
        ตัดสินใจลงทุน
      </p>
    </section>

    <div class="spacer"></div>

    <section id="cta-model">
      <a class="cta-btn" v-on:click="openRecommend">รับคำแนะนำการลงทุน</a>
    </section>
  </article>
</template>
<script>
import axios from "axios";
import { sendAnalytic } from "../../utils/analytic";
import { GetRankClass } from "../../utils/fund";
import PlusConfig from "../../config/plus-config.json";

export default {
  components: {},
  props: { userID: String, env: Object, finnakies: String },
  metaInfo: {
    title: "โมเดลพอร์ต"
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_FINNOMENA_URL,
      fundData: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    getRank(num) {
      return GetRankClass(num).title;
    },
    getClass(num) {
      return GetRankClass(num);
    },
    openRecommend: function() {
      sendAnalytic({
        luid: this.userID,
        de: "line",
        ac: "click_open_recommend",
        ec: "create_flow",
        un: this.finnakies,
        in: this.$route.query.initial,
        ri: this.$route.query.risklevel,
        pl: this.$route.query.plan ? this.$route.query.plan.toUpperCase() : "",
        cu: "sample_port_" + this.$route.query.plan,
        et: "on_click"
      });

      this.$router.push({
        name: "appintro",
        params: {
          userID: this.userID,
          finnakies: this.finnakies
        },
        query: this.$route.query
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  async created() {
    try {
      let { data } = await axios.get(
        `/api/fund/public/${PlusConfig.fund_id}/overview`
      );

      this.fundData = data ? data : {};
    } catch (err) {
      // console.error(err);
    }
  },
  async mounted() {
    sendAnalytic({
      luid: this.userID,
      de: "line",
      ac: "open",
      ec: "create_flow",
      un: this.finnakies,
      cu: "sample_port_" + this.$route.query.plan,
      et: "on_load"
    });
  },
  filters: {
    percent: function(value) {
      if (value) {
        return Number(value).toFixed(2) + "%";
      }

      return "-";
    }
  }
};
</script>
<style lang="scss" scoped>
#article-model {
  padding: 16px;
  max-width: 450px;
  margin: 0 auto;

  #port-detail {
    .header {
      display: flex;

      img {
        width: 4em;
        height: 4em;
        object-fit: contain;
      }

      .header-detail {
        margin-left: 8px;
        h1 {
          margin-bottom: 0;
        }

        p {
          margin-top: 0;
        }
      }
    }

    h2 {
      font-size: 16px;
      font-weight: bold;
      margin-top: 24px;
    }

    .capsule {
      visibility: hidden;
      display: inline-block;
      color: $color-white;
      border-radius: 16px;
      font-size: 9px;
      width: 35px;
      padding: 0;
      text-align: center;
      margin: 0 auto;
      text-decoration: none;
    }

    .unknown {
      content: "";
      visibility: hidden;
    }

    .medium {
      content: "ปานกลาง";
      visibility: hidden;
      background-color: #777777;
    }

    .excellent {
      content: "ดีมาก";
      visibility: visible;
      background-color: #00af50;
    }

    .good {
      content: "ดี";
      visibility: visible;
      background-color: #57bc85;
    }

    .great {
      content: "ดีที่สุด";
      visibility: visible;
      background-color: #25c970;
    }

    .hiden {
      visibility: hidden;
    }

    p {
      font-size: 14px;
      color: $color-secondary-text;
    }

    img {
      max-width: 70%;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    th {
      font-size: 12px;
      color: $color-secondary-text;
      font-weight: normal;
      height: 45px;
    }

    td {
      font-size: 14px;
      font-weight: bold;
      height: 64px;
      align-items: center;
      align-content: center;
    }

    table,
    th,
    td {
      text-align: center;
    }

    th,
    td {
      padding: 1em;
      border: solid 1px #e4e8ea;
    }
  }

  #disclaimer {
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $color-secondary-text;
  }

  .spacer {
    margin-top: 62px;
    clear: both;
  }

  #cta-model {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    text-align: center;
    margin: 0;
    padding: 0;

    .cta-btn {
      text-decoration: none;
      @extend %btn-primary;
      font-style: normal;
      font-stretch: normal;
      padding: 12.5px 0;
      width: -webkit-fill-available;
    }
  }
}
</style>


